import bannerimg from './assets/bannerimg.png'
import Home from './components/Home'
import About from './components/About'
import Tokenomics from './components/Tokenomics'
import Howtobuy from './components/Howtobuy'
import Join from './components/Join'

function App() {
  return (
    <div className="overflow-clip">
      <div className="flex flex-col justify-center items-center relative min-h-screen b  text-black py-20 px-4">
        <h1 className="text-5xl font-bold mb-8 text-center  ">
          Wally is Being Reborn!
        </h1>

        <div className="max-w-3xl text-center space-y-6">
          <p className="text-xl leading-relaxed">
            Wally is undergoing an exciting transformation with a new launch and migration to an enhanced contract. Our renewed community vision focuses on leveraging the power of meme coins to create positive impact across the globe.
          </p>

          <p className="text-lg ">
            We're building something special - a platform where digital value meets real-world change. Stay tuned while we construct the future of community-driven impact.
          </p>

          <div className="mt-12">
            <h2 className="text-2xl   mb-4  ">
              Evolving Digital Value to Impact Real Change
            </h2>
            <p className=" ">
              Join us on this journey as we redefine what's possible when community, technology, and purpose align.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
